import React from 'react';

import styles from './styles.module.scss';
import Button from "@components/Button";
import {navigate} from "@reach/router";

const Error = ({ title = 'Whoops', text = '', error = {} }) => (
    <div className={styles.error}>
        <h1>{title}</h1>
        <p>{text || (error?.errorMessage ?? 'Something went wrong 😭')}</p>
        <div className={styles.errorButton}>
            <Button text="Go back" onClick={() => navigate(-1)} />
        </div>
    </div>
);

export default Error;
